export function toEnglishDigits(str: string | number): string {
  // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
  let e = '۰'.charCodeAt(0);
  str = str
    .toString()
    .replace(/[۰-۹]/g, (t) =>
      String.fromCharCode(t.charCodeAt(0) - e + '0'.charCodeAt(0))
    );

  // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
  e = '٠'.charCodeAt(0);
  str = str
    .toString()
    .replace(/[٠-٩]/g, (t) =>
      String.fromCharCode(t.charCodeAt(0) - e + '0'.charCodeAt(0))
    );
  return str;
}
